import React from 'react';
import { Grid } from '@mui/material';
import { RemoveCircle, AddCircle } from '@mui/icons-material';
import { OutlinedTextInput, TinyIconButton, Colors, Text } from 'library';

export default function SlotsPicker({
    label,
    slotsAvailable,
    setSlotsAvailable,
}: {
    label: string;
    slotsAvailable: number;
    setSlotsAvailable: (slotsAvailable: number) => void;
}) {
    return (
        <Grid container item direction="row" alignItems="center" gap={2} marginTop={2}>
            <OutlinedTextInput
                type="number"
                label={label}
                value={slotsAvailable}
                onChange={(e) => setSlotsAvailable(parseInt(e.target.value))}
                style={{ width: 150 }}
                InputLabelProps={{ shrink: true }}
                id="job-form-slots-input"
            />
            <Text>Worker{(slotsAvailable ?? 0) > 1 ? 's' : ''}</Text>
            <TinyIconButton
                onClick={() => {
                    setSlotsAvailable((slotsAvailable || 1) > 1 ? (slotsAvailable || 1) - 1 : 1);
                }}
            >
                <RemoveCircle htmlColor={Colors.darkNavy} />
            </TinyIconButton>
            <TinyIconButton
                onClick={() => {
                    setSlotsAvailable((slotsAvailable || 1) + 1);
                }}
            >
                <AddCircle htmlColor={Colors.darkNavy} />
            </TinyIconButton>
        </Grid>
    );
}
